const {
    Component
} = Shopware;

import template from './sw-cms-preview-manufacturer-block.html.twig';

Component.register('sw-cms-preview-manufacturer-block', {
    template
});